import script from "./Avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"Avatar.vue"]])

export default __exports__